import { differenceInDays, now } from 'owa-datetime';
import { getFirstOWAReactMiniLogon } from 'mini-common-utils/lib/utils/getFirstOWAReactMiniLogon';

export const isNewToMini = (): boolean => {
    const firstOWAReactMiniLogon = getFirstOWAReactMiniLogon();
    if (!firstOWAReactMiniLogon) {
        return false;
    }

    const diffInDays = differenceInDays(now(), firstOWAReactMiniLogon);
    return diffInDays <= 30;
};
